<template>
  <div class="wrapper flex page-wrapper">
    <div class="left flexnone">
      <Input placeholder="搜索" @on-change="setTreeData"
             v-model="searchText"
      />
      <Tree :data="treeData" ref="tree" @on-select-change="findList"></Tree>
    </div>
    <div class="right flexauto page-wrapper">
      <Button type="primary" class="mb16" @click.stop="toAdd"
              v-p="{api:'organ/add'}"
      >添加</Button>
      <table-list
        title="" :columns="columns"
        :data="dataTable"
        :loading="loading"
        :total="total"
        :current="current"
        @change-page="changePage"
      ></table-list>
      <add :n="addN"
           :parentName="parentName"
           :parentUid="parentUid"
           @done="init"
      ></add>
      <update :data="updateData" :n="updateN" v-if="updateData" @done="organList(searchedId)"></update>
    </div>
  </div>
</template>

<script>
  import TableList from "components/TableList/index";
  import Add from './components/Add'
  import Update from './components/Update'

  import {organTree, organList, organdelete} from "../../../api/systemmanage";
  import {setTitleAndOthers, filterArr, setFirstSelected} from "../js/systemmanage";
  import {formatDateTime} from "../../../utils/format";

  export default {
    name: "organization",
    components: {
      TableList,
      Add,
      Update

    },
    data() {
      return {
        updateData:null,
        updateN:0,
        parentUid:'',
        parentName: '',
        searchedId: '',
        treeData: [],
        searchText: '',
        addN: 0,
        data: [],
        page: 1,
        current: 1,
        limit: 10,
        total: 0,
        dataTable: [],
        loading: false,
        columns: [
          {
            type: 'index',
            width: 60,
          },
          {title:' '},

          {
            title: '机构代码',
            key: 'organCode',
            align: 'center',
            width:150,
          },
          {title:' '},
          {
            title: '机构名称',
            key: 'organName',
            align: 'center',
            width:100,

          },
          {title:' '},
          {
            title: '是否区域',
            key: 'hasShop',
            align: 'center',
            render: (h, params) => {
              return h('span', {}, params.row['hasShop'] === true ? '是' : '否')
            },
            width:100,

          },
          {title:' '},
          {
            title: '上级机构',
            key: 'parentOrganName',
            align: 'center',
            width:100,

          },
          {title:' '},
          {
            title: '负责人',
            key: 'leaderName',
            align: 'center',
            width:120,
          },
          {title:' '},
          {
            title: '创建人',
            key: 'creator',
            align: 'center',
            width:120

          },
          {title:' '},
          {
            title: '创建时间',
            key: 'createTime',
            align: 'center',
            render:(h,params)=>{
              return h('span',{},this.format(params.row['createTime'],false))
            },
            width:160,
          },
          {title:' '},
          {
            title: '操作',
            key: 'action',
            align: 'center',
            render: (h, params) => {
              let deleteItem = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'organ/delete'
                    }
                  }
                ],
                style: {
                  marginLeft: '10px'

                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '组织机构删除',
                      content: '<p>确认删除？</p>',
                      onOk: () => {
                        organdelete({organId: params.row['organId']}).then(
                          res => {

                            this.page = 1;
                            this.organList(this.searchedId);
                            this.$Message.success('组织机构删除成功');
                            this.organTree()
                          }
                        ).catch(error => {
                        })
                      }
                    })
                  }
                }

              }, '删除');
              let edit = h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'organ/modify'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.updateData=params.row;
                    this.$nextTick(()=>{
                      this.updateN++
                    })

                  }
                }
              }, '编辑');
              return h('div', {}, [edit, deleteItem])
            },
            width:100,


          },

        ],

      }
    },
    methods: {
      init(){
        this.organTree().then(res => {
          let checked = this.$refs['tree'].getSelectedNodes();
          this.findList(checked)

        }).catch().finally(() => {

        })

      },
      organList(value) {
        let params = {
          page: 1,
          pageSize: 10,
          parentUid: value

        };
        organList(params).then(res => {
          if (!res.data) {
            return
          }
          this.dataTable = res.data.rows;
          this.total = res.data.total;
          this.searchedId = value

        }).catch(error => {
        })

      },

      findList(value) {
        if (!value || value.length === 0) {
          return
        }
        this.organList(value[0].value)

      },

      setTreeData: function () {
        if (!this.searchText) {
          this.treeData = this.data
        }
        else {
          this.treeData = filterArr(this.data, this.searchText)
        }
      },
      organTree() {
        return organTree().then(res => {
          if (!res.data) {
            return
          }
          let data = res.data;
          setTitleAndOthers(data);
          setFirstSelected(data);
          this.data = data;
          this.treeData = this.data
        }).catch(error => {

        })

      },
      toAdd() {
        let checked = this.$refs['tree'].getSelectedNodes();
        if(!checked || !checked.length){
          this.$Message.info('无组织机构信息')
          return
        }
        this.parentName = checked[0].title;
        this.parentUid=checked[0].value;
        this.addN++

      },
      changePage(n) {
        let checked = this.$refs['tree'].getSelectedNodes();
        this.current = n;
        this.page = n;
        this.findListChange(checked, n)
      },
      findListChange(value, n){
        if (!value || value.length === 0) {
          return
        }
        let params = {
          page: n,
          pageSize: 10,
          parentUid: value[0].value

        };
        organList(params).then(res => {
          if (!res.data) {
            return
          }
          this.dataTable = res.data.rows;
          this.total = res.data.total;
          this.searchedId = value

        }).catch(error => {
        })
      },
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, true)
      },
    },
    created() {
      this.init()

    }


  }
</script>

<style scoped>
  .wrapper {
    /*display: flex;*/
  }

  .left {
    /*flex: none;*/
    width: 200px;
    /*height: 100%;*/
    height: 80vh;
    box-sizing: border-box;
    overflow: auto;
    padding: 10px;
    border: 1px solid #dcdcdc;
    margin-right: 10px;
    /*background-color: lightgray;*/

  }

</style>
